

import React from 'react'
import Header from './../inc/Header';
import Slider from "../inc/Slider";

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Roomimg from "../pages/Roomimg";

import Hotel from "../images/hotel.jpeg";
import Hotelberhampore from "../images/hotelvip.jpeg";
import anypartybooking from "../images/partybooking.jpeg";

import hazarduari from "../images/hazarduari-palace.jpg";
import motijhilpark from "../images/toy-train.jpg";
import Kathgola from "../images/kathgola-palace.jpg";
import ImambaraBerhampore from "../images/imambara.jpg";
import katramasjidb from "../images/katramasjid.jpg";
import Berhamporelodge from "../pages/Berhamporelodge";
import Pinewood from "../pages/Pinewood";

import berhamporelodge from "../images/BERHAMPORE LODGE _FRONT.jpeg";
import berhamporelodgeinteror from "../images/Berhampore lodge Interior.jpeg";
import berhamporelodgereceiption from "../images/Receiption_berhamporeLodge.jpeg"


import "./Home.css";
import Berhamporehotel from './Berhamporehotel';
import HotelpinewoodroomBooking from './HotelpinewoodroomBooking';
import Rooftop from './Rooftop';
function Home() {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };
  return (
    <div>
      <Header />
      <br />
      <br />

      <div className="album py-2">

        <div className="container">
          <div className="row">

            <h5>Berhampore Lodge</h5>
          </div>
        </div>
      </div>
      <div className="album py-2">

        <div className="container">
          <div className="row">
            <div className="col-md-8 mt-3">
              <Slider />

            </div>
            <div className="col-md-4 mt-3">
              <div class="card border-priamry text-white mb-3" >
                <div class="card-header"><h6 style={{ color: "maroon" }} className='mt-2'><center><h5 className="blink" style={{ color: "maroon" }}> IMPORTANT LINK </h5></center></h6></div>
                <div class="card-body ">
                  <a href='Hotel-Pinewood'>
                    <div className="btn-grad50  mb-2">  HOTEL PINEWOOD <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></div></a >



                  <a href='Berhampore-lodge'>
                    <div className="btn-grad50  mb-2"> BERHAMPORE LODGE <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></div></a >


                  <a href='services'>
                    <div className="btn-grad50  mb-2">  SERVICES <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></div></a >
                  <a href='rooftop-restraurant'>
                    <div className="btn-grad50  mb-2">  ROOF TOP RESTAURANT <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></div></a >
<a href='menu'>
                    <div className="btn-grad50  mb-2">  MENU <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg></div></a >

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='besthotelinberhampore'>
        <div className="album py-1">
          <div className="container mt-2">
            <div className="row">
              <marquee>
                <h5 style={{ color: "white" }} className=''>Welcome to Berhampore Lodge, 5, R.N TAGORE ROAD, BERHAMPORE, LALDIGHI, MURSHIDABAD, PIN- 742101, WEST BENGAL, INDIA</h5>
              </marquee>
            </div>
          </div>
        </div>
      </div>


      <div className="album py-2">

        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="card" >
                <img src={berhamporelodge} className="card-img-top" alt="berhamporelodge" />
                <div className="card-body">
                  <h5 className="card-title">Bberhampore Lodge Front</h5>
                  <p className="card-text">Best Hotel in Berhampore</p>

                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card" >
                <img src={berhamporelodgeinteror} className="card-img-top" alt="berhamporelodgeinteror" />
                <div className="card-body">
                  <h5 className="card-title">Bberhampore Lodge Front</h5>
                  <p className="card-text">Best Hotel in Berhampore</p>

                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card" >
                <img src={berhamporelodgereceiption} className="card-img-top" alt="berhamporelodgereceiption" />
                <div className="card-body">
                  <h5 className="card-title">Bberhampore Lodge Front</h5>
                  <p className="card-text">Best Hotel in Berhampore</p>

                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
      <div style={{ color: "Gray", padding: "14px;", margin: "3px" }} className="fixed-bottom "> <a href="tel: +91 9474316200" style={{color:"white"}} className="newbutton" > <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-phone" viewBox="0 0 16 16">
        <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z" />
        <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
      </svg>  Hotel Booking  </a></div>
      <br />


      <Berhamporehotel />
      <br />

      <HotelpinewoodroomBooking />
        <div className="album py-0">

        <div className="container">
                      <h2><b>ROOF TOP RESTAURANT </b></h2>

          </div>
        </div>

        <Rooftop/>
        <br/>
        <hr/>
      <div className="album py-0">

        <div className="container">

          <div className="row">
            <h2><b>EXPLORE BERHAMPORE LODGE</b></h2>


          </div>
        </div>
      </div>


      <div className="album py-2">

        <div className="container">

          <div className="row">

            <Carousel responsive={responsive}>
              <div className="card border mb-3 me-3" >
                <img className="card-img-top" src={Hotel} alt="Berhampore_Hotel" />
                <div className="card-body text">
                  <div className="alert alert-primary " role="alert">

                    <center>
                      <h6 className="card-title mb-0"><b>Berhampore Lodge </b></h6>
                      <p className="card-text"><small>Any Party Booking</small></p>
                    </center>
                  </div>
                </div>
              </div>
              <div className="card border mb-3 me-3" >
                <img className="card-img-top" src={Hotelberhampore} alt="Berhampore_Hotel" />
                <div className="card-body text">
                  <div className="alert alert-danger " role="alert">
                    <center>
                      <h6 className="card-title mb-0"><b>Berhampore Lodge </b></h6>
                      <p className="card-text"><small>Any Party Booking</small></p>
                    </center>
                  </div>
                </div>
              </div>
              <div className="card border mb-3 me-3" >
                <img className="card-img-top" src={anypartybooking} alt="Berhampore_Hotel" />
                <div className="card-body text">
                  <div className="alert alert-info " role="alert">
                    <center>
                      <h6 className="card-title mb-0"><b>Berhampore Lodge </b></h6>
                      <p className="card-text"><small>Any Party Booking</small></p>
                    </center>
                  </div>
                </div>
              </div>
              <div className="card border mb-3 me-3" >
                <img className="card-img-top" src={anypartybooking} alt="Berhampore_Hotel" />
                <div className="card-body text">
                  <div className="alert alert-warning" role="alert">
                    <center>
                      <h6 className="card-title mb-0"><b>Berhampore Lodge </b></h6>
                      <p className="card-text"><small>Any Party Booking</small></p>
                    </center>
                  </div>
                </div>
              </div>




            </Carousel>
          </div>
        </div>

      </div>
      <br />

      <div className="album py-1">

        <div className="container">

          <div className="row">
            <h2 style={{ color: "maroon" }}><b>Hotel Pinewood Room, Best Hotel in Berhampore</b></h2>


          </div>
        </div>
      </div>
      <Roomimg />
      <div className="album py-2">

        <div className="container">

          <div className="row">
            <h2><b>BERHAMPORE HISTORICAL PLACES</b></h2>


          </div>
        </div>
      </div>


      <div className="album py-2">

        <div className="container">

          <div className="row">

            <Carousel responsive={responsive}>
              <div className="card border mb-3 me-3" >
                <img className="card-img-top" src={hazarduari} alt="hazarduari" />
                <div className="card-body text">
                  <center>
                    <h6 className="card-title mb-0"><b>HAZAR DUARI </b></h6>
                    <p className="card-text"><small>Speciality Museums</small></p>
                  </center>
                </div>
              </div>
              <div className="card border mb-3 me-3" >
                <img className="card-img-top" src={motijhilpark} alt="motijhilpark" />
                <div className="card-body text">
                  <center>
                    <h6 className="card-title mb-0"><b>Motijheel Park </b></h6>
                    <p className="card-text"><small>Amusement & Theme Parks</small></p>
                  </center>
                </div>
              </div>
              <div className="card border mb-3 me-3" >
                <img className="card-img-top" src={Kathgola} alt="Kathgola" />
                <div className="card-body text">
                  <center>
                    <h6 className="card-title mb-0"><b>Kathgola Gardens</b></h6>
                    <p className="card-text"><small>Gardens</small></p>
                  </center>
                </div>
              </div>
              <div className="card border mb-3 me-3" >
                <img className="card-img-top" src={ImambaraBerhampore} alt="ImambaraBerhampore" />
                <div className="card-body text">
                  <center>
                    <h6 className="card-title mb-0"><b>Imambara</b></h6>
                    <p className="card-text"><small>Architectural Buildings • Religious Sites</small></p>
                  </center>
                </div>
              </div>
              <div className="card border mb-3 me-3" >
                <img className="card-img-top" src={katramasjidb} alt="KatraMasjid" />
                <div className="card-body text">
                  <center>
                    <h6 className="card-title mb-0"><b>Katra Masjid </b></h6>
                    <p className="card-text"><small>Historic Sites</small></p>
                  </center>
                </div>
              </div>


            </Carousel>
          </div>
        </div>

      </div>
      <br />
    </div >
  )
}

export default Home
